import React from 'react';

const KeyChangeIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <g transform='translate(7.000000, 6.000000)'>
        <path d='M4.5,0 C6.5,0 8.1,1.2 8.7,3 L18,3 L18,6 L15,6 L15,9 L12,9 L12,6 L8.7,6 C8.1,7.8 6.4,9 4.5,9 C2,9 0,7 0,4.5 C0,2 2,0 4.5,0 M4.5,3 C3.7,3 3,3.7 3,4.5 C3,5.3 3.7,6 4.5,6 C5.3,6 6,5.3 6,4.5 C6,3.7 5.3,3 4.5,3 M4.5,11 C6.5,11 8.1,12.2 8.7,14 L18,14 L18,17 L17,17 L17,20 L15,20 L15,17 L13,17 L13,20 L10,20 L10,17 L8.7,17 C8.1,18.8 6.4,20 4.5,20 C2,20 0,18 0,15.5 C0,13 2,11 4.5,11 M4.5,14 C3.7,14 3,14.7 3,15.5 C3,16.3 3.7,17 4.5,17 C5.3,17 6,16.3 6,15.5 C6,14.7 5.3,14 4.5,14 Z' />
      </g>
    </g>
  </svg>
);

export default KeyChangeIcon;
